import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    currencies: [],
    currenciesMetadata: {},
    currency: {},
    currencyMetadata: {}
  }
})
  .get({
    action: 'getCurrencies',
    property: 'currencies',
    queryParams: true,
    path: '/currencies/',
    onSuccess: payloadToState('currencies')
  })
  .post({
    action: 'createCurrency',
    property: 'currency',
    path: '/currencies/',
    onSuccess: payloadToState('currency')
  })
  .get({
    action: 'getCurrency',
    property: 'currency',
    path: ({ id }) => `/currencies/${id}`,
    onSuccess: payloadToState('currency')
  })
  .put({
    action: 'updateCurrency',
    property: 'currency',
    path: ({ id }) => `/currencies/${id}`,
    onSuccess: payloadToState('currency')
  })
  .delete({
    action: 'deleteVodCurrency',
    property: 'currency',
    path: ({ id }) => `/currencies/${id}`,
    beforeRequest: getOptimisticDelete('currencies'),
    onSuccess: payloadToState('currency')
  })
  .delete({
    action: 'deleteCurrency',
    property: 'currency',
    path: ({ id }) => `/currencies/${id}`,
    beforeRequest: getOptimisticDelete('currencies'),
    onSuccess: payloadToState('currency')
  })
  .getStore()
